import {Component, Output, Input, EventEmitter, Inject, OnInit, ChangeDetectorRef} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RestUrlService, TypeUrl } from '../../../core/services/api.services/settings/rest-url.service';

@Component({
  selector: 'info-drag-picture',
  templateUrl: './info-drag-picture.component.html',
  styleUrls: ['./info-drag-picture.component.sass'],
})
export class InfoDragPictureComponent implements OnInit {
  @Input() image: string;
  @Input() name: string;
  @Input() currentLang: string;
  @Output() onClickPicture: EventEmitter<any> = new EventEmitter();

  public isImageLoaded = false;
  public images: string;

  public width = 500;
  public height = 375;

  constructor(
    private readonly url: RestUrlService,
    private cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.images = this.url.getUrl(TypeUrl.img) + `/${this.width.toString()}-${this.height.toString()}/`;
  }

  ngOnInit(): void {
    if (this.image) {
      this.isImageLoaded = true;
      this.addPreloadLink(this.image);
    }
  }

  public clickOnPicture(): void {
    this.onClickPicture.emit();
  }

  public onImageLoad(): void {
    this.isImageLoaded = true;
    this.cdr.detectChanges();
  }

  public onImageLoadError(): void {
    this.isImageLoaded = false;
    this.cdr.detectChanges();
  }

  private addPreloadLink(imageName: string): void {
    const webpUrl: string = this.images + imageName + '.webp';
    const link: HTMLLinkElement = this.document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = `https:${webpUrl}`;


    link.setAttribute('imagesrcset', `https:${webpUrl}`);
    link.setAttribute('imagesizes', `${this.width.toString()}px`);

    this.document.head.appendChild(link);
  }
}
